export default __webpack_public_path__ + "static/media/bookmark1.b09aea67.svg";